// extracted by mini-css-extract-plugin
export default {"container":"container_txaHj","tabs":"tabs_NuKQ2","links":"links_nrG9W"};